import { Text } from '@mantine/core';

interface H2Props {
  text: string
  fontSize: string
  fontWeight: number
  textAlign?: "start" | "end" | "left" | "right" | "center" | "justify" | "match-parent";
}

export default function H2( { text, fontSize, fontWeight, textAlign }: H2Props ) {
  return (
    <>
    <Text weight={fontWeight} style={{ color: '#0f182d', fontFamily: '', fontSize: fontSize, textAlign: (textAlign ?  textAlign : 'start') }}> 
        {text}
    </Text>
    </>
  );
}